<div class="monitor-time-box" ng-style="{'margin-bottom' : timelineHeight}">{{currentDate}}</div>
<div class="live-label">LIVE</div>
<div class="live-vertical-line"></div>
<div #timelineContainer id="visJsMonitorTimeline"></div>